// Net-new SUF JavaScript. Native ES module — no bundler.
//
// Loaded from layout/theme.liquid with:
//   <script src="//www.showupfitness.com/cdn/shop/t/9/assets/suf.js?v=77571436411921395021788371911" type="module"></script>
//
// A .liquid asset is served at its plain name, so that tag needs no change.
//
// EVERY IMPORT MUST GO THROUGH asset_url. The CDN caches theme assets for a
// year and keys them on the `v` parameter alone -- it ignores any other query
// string. A bare `import "./suf-nav.js"` therefore pins visitors to whatever
// copy the edge cached, for a year, while the theme and the repo both show the
// new file and a pull confirms it. asset_url emits the versioned URL, which is
// the only form that invalidates.
//
// That is what this file being Liquid is for. Adding a module means adding it
// here in the same form; assets/ is flat, so the filter's argument is the whole
// path. Importing from npm is still the point at which we would add Vite.
//
// type="module" is deferred by default, so the DOM is already parsed here.

import "//www.showupfitness.com/cdn/shop/t/9/assets/suf-nav.js?v=62242448003437990321789663468";
import "//www.showupfitness.com/cdn/shop/t/9/assets/suf-motion.js?v=143273955644344490291788212973";
import "//www.showupfitness.com/cdn/shop/t/9/assets/suf-search.js?v=182420627074992942481788212973";
import "//www.showupfitness.com/cdn/shop/t/9/assets/suf-form.js?v=179174438416346065131788212973";
import "//www.showupfitness.com/cdn/shop/t/9/assets/suf-totop.js?v=15696181151991595131788397530";
import "//www.showupfitness.com/cdn/shop/t/9/assets/suf-bundle.js?v=9882118553057407001789764718";

console.debug("[suf] loaded");
